@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.addBorder(@prop:'left') {
  border-@{prop}: 1px solid @line-item--mixin-add-border--border-color;
}

.item-display {
  display: flex;
  overflow: hidden;
  flex: 1;
}

.tile {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: right;
  background-color: @line-item--background-color;
}

.item-display-wrapper {
  background-color: @line-item--background-color;
  flex: 5;
  text-align: left;
  padding: 10px 0;
  min-width: 0;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
}

.content {
  align-self: center;
}

.row {
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.item-image {
  height: 50px;
  width: 50px;
  min-width: 50px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  > img,
  > svg {
    max-height: 100%;
    max-width: 100%;
  }

  &.empty-image {
    background: @line-item--empty-image--background-color;
    padding: 10px;

    > svg {
      width: 30px;
      height: 30px;
      color: @line-item--empty-image--fill-color;
    }
  }
}

.tooltip-image-wrapper {
  padding: 0;
}

.tooltip-image {
  height: 300px;
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    max-height: 100%;
    max-width: 100%;
  }
}

.non-image-content {
  display: flex;
  width: calc(100% - 70px);
  font-size: 14px;
}

.text-content {
  width: 100%;
  margin-right: 10px;

  button {
    text-align: left;
  }
}

.item-sku {
  margin-top: 5px;
}

.description-link {
  cursor: pointer;
  font-weight: @bold;
  margin-top: 5px;
}

.item-descriptions {
  color: @line-item--descriptions--text-color;
  margin-top: 5px;
  overflow-wrap: break-word;
}

.description {
  font-size: 14px;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }

  > b {
    margin-right: 5px;
  }
}

.item-price-quantity {
  display: flex;
  height: 100%;
  flex: 1;
  max-height: 50px;
}

/* read only qty */
.quantity-wrapper {
  background: @line-item--background-color;
  text-align: center;
  align-self: flex-start;
  padding: 9px 14px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  &.greater-than-two {
    background: @line-item--quantity-greater-than-two--background-color;
    border: 1px solid @line-item--quantity-greater-than-two--border-color;
  }

  &.has-four-digits {
    padding: 9px 10px;
  }
}

.quantity-column {
  padding: 10px 0;
}

.number {
  font-size: 32px;
  color: @line-item--number--text-color;
}

.quantity {
  display: flex;
  flex-direction: column;
}

/* inventory */
.loading-indicator {
  padding: 0;
  margin: 10px;
  place-self: center center;
  width: 75px;
}

.inventory-wrapper {
  font-size: 14px;
  background-color: @line-item--background-color;

  > *:not(:last-child) {
    padding-bottom: 10px;
  }
}

.inventoryCountMixin() {
  display: flex;
  justify-content: space-between;

  .inventory-padding {
    padding-right: 5px;
  }
}

.inventoryColorMixin(@background, @border) {
  background-color: @background;
  color: @border;
}

.red {
  .inventoryCountMixin();
  color: @line-item--red--text-color;
}

.green {
  .inventoryCountMixin();
  color: @line-item--green--text-color;
}

.black {
  .inventoryCountMixin();
}

.unknown-message {
  color: @line-item--unknown-message--text-color;
  flex-wrap: wrap;
  max-width: 115px;
  font-size: 13px;
  justify-content: flex-start;
  text-align: left;
}

.inventoryIconMixin(@border,@fill) {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid @border;
  margin-top: 2px;
  padding: 8px;

  svg {
    width: 16px;
    height: 16px;
    color: @fill;
  }
}

.red-background {
  .inventoryIconMixin(@line-item--red--border-color, @line-item--red--fill-color);
  background-color: @line-item--red--background-color;

  svg {
    width: 12px;
    height: 12px;
  }
}

.green-background {
  .inventoryIconMixin(@line-item--green--border-color, @line-item--green--fill-color);
  background-color: @line-item--green--background-color;

  svg {
    width: 14px;
    height: 14px;
  }
}

.blue-background {
  .inventoryIconMixin(@line-item--blue--border-color, @line-item--blue--fill-color);
  background-color: @line-item--blue--background-color;
}

.black-background {
  .inventoryIconMixin(@line-item--black--border-color, @line-item--black--fill-color);
  background-color: @line-item--black--background-color;
}

.line-item-adjustment-notice {
  margin: 5px 0 0;
  background-color: @line-item--adjustment-notice--background-color;
  height: 24px;
  max-width: 300px;
  display: inline-flex;
  flex-flow: row wrap;
  align-items: center;
  padding-right: 5px;
  border-radius: 2px;
}

.notice-svg {
  transform: scale(0.8);
  color: @line-item--notice--fill-color;
  height: 20px;
  width: 25px;
}

.dangerous-goods-tag {
  margin-top: 5px;
}
